import PropTypes from 'prop-types';

const HeaderMessage = ({ completed, length, initial, multiple, complete }) => {
  const initialMessage = length > 1 ? multiple : initial;
  const message = completed ? complete : initialMessage;

  return message;
};

HeaderMessage.propTypes = {
  completed: PropTypes.bool,
  length: PropTypes.number,
  initial: PropTypes.string,
  multiple: PropTypes.string,
  complete: PropTypes.string,
};

HeaderMessage.defaultProps = {
  completed: false,
  length: 1,
};

export default HeaderMessage;
